import React, { Component } from 'react';
import {getCurrentLocale} from 'service/LocaleService';

import SplitterLayout from 'react-splitter-layout';

//import RSplitPane from 'react-split-pane';
import './splitPane.scss';

export default class SplitPane extends Component {

    render() {
        const {id, store, children, ...otherProps} = this.props;
        let newProps = {...otherProps};
        if(store) {
            newProps = {
                ...newProps,
                defaultSize: parseInt(localStorage.getItem(id + 'SplitPos'), 10),
                onChange: size => localStorage.setItem(id + 'SplitPos', size),
            }
        }
        return (
            <SplitterLayout customClassName="asplitpane" {...newProps}>
                {children}
            </SplitterLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/splitPane/SplitPane.js